module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "list-block"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("手机或邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('account')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.account),
      expression: "account",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "id": "account",
      "placeholder": "帐号"
    },
    domProps: {
      "value": (_vm.account)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.account = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("验证码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.veriCode),
      expression: "veriCode",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "veriCode",
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.veriCode)
    },
    on: {
      "click": function($event) {
        return _vm.autofocus('veriCode')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.veriCode = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline",
      "width": "2.5rem"
    }
  }, [_c('a', {
    attrs: {
      "id": "btn"
    },
    on: {
      "click": _vm.sendVeriCode
    }
  }, [_vm._v("发送")])])])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("新密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('newPassword')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newPassword),
      expression: "newPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "newPassword",
      "type": "password",
      "placeholder": "新密码"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type === 'phone'),
      expression: "type === 'phone'"
    }]
  }, [_c('div', {
    staticClass: "item-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-title label"
  }, [_vm._v("确认密码")]), _vm._v(" "), _c('div', {
    staticClass: "item-input",
    on: {
      "click": function($event) {
        return _vm.autofocus('confirmPassword')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.confirmPassword),
      expression: "confirmPassword",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "width": "6rem",
      "display": "inline"
    },
    attrs: {
      "id": "confirmPassword",
      "type": "password",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.type === 'phone') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")])]) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('div', {
    staticClass: "col-100"
  }, [_c('a', {
    staticClass: "button button-big button-fill button-success",
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("发送邮件")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("忘记密码")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-name"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('i', {
    staticClass: "icon icon-form-password"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21af0417","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/MyLogin/ForgetPassword.vue
// module id = 1565
// module chunks = 8